import { create } from 'zustand'

export type ModalType = 'login' | 'message' | 'share' | 'forgot-password' | null
export type ToastType = 'success' | 'error' | 'info' | 'warning'

export interface Toast {
  id: string
  message: string
  type: ToastType
}

interface ModalData {
  listingId?: string
  sellerId?: string
  sellerName?: string
  listingTitle?: string
  listingImage?: string
  listingPrice?: number
  [key: string]: unknown
}

interface UIState {
  // Modal state
  activeModal: ModalType
  modalData: ModalData

  // Toast state
  toasts: Toast[]

  // Mobile UI state
  mobileMenuOpen: boolean
  mobileFiltersOpen: boolean

  // Actions
  openModal: (modal: ModalType, data?: ModalData) => void
  closeModal: () => void
  showToast: (message: string, type?: ToastType) => void
  removeToast: (id: string) => void
  toggleMobileMenu: () => void
  closeMobileMenu: () => void
  toggleMobileFilters: () => void
  closeMobileFilters: () => void
}

export const useUIStore = create<UIState>((set, get) => ({
  activeModal: null,
  modalData: {},
  toasts: [],
  mobileMenuOpen: false,
  mobileFiltersOpen: false,

  openModal: (modal, data = {}) => set({ activeModal: modal, modalData: data }),

  closeModal: () => set({ activeModal: null, modalData: {} }),

  showToast: (message, type = 'success') => {
    const id = Date.now().toString()
    set({ toasts: [...get().toasts, { id, message, type }] })
    // Auto-remove after 5 seconds
    setTimeout(() => get().removeToast(id), 5000)
  },

  removeToast: (id) =>
    set({ toasts: get().toasts.filter((t) => t.id !== id) }),

  toggleMobileMenu: () => set({ mobileMenuOpen: !get().mobileMenuOpen }),

  closeMobileMenu: () => set({ mobileMenuOpen: false }),

  toggleMobileFilters: () => set({ mobileFiltersOpen: !get().mobileFiltersOpen }),

  closeMobileFilters: () => set({ mobileFiltersOpen: false }),
}))
